import React from "react";
import { Plural, Trans } from "@lingui/macro";
import * as styles from "./CruiseRecap.module.scss";
import DateOnlyFormat from "components/DateOnlyFormat";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export interface CruiseRecapProps {
  shipName?: string;
  departureDate?: string | Date;
  arrivalDate?: string | Date;
  duration?: number;
}

const CruiseRecap: React.FC<CruiseRecapProps> = ({
  shipName,
  departureDate,
  arrivalDate,
  duration
}) => {
  return (
    <div
      className={cx({
        cruiseRecap: true,
        withArrivalDate: !!arrivalDate
      })}
    >
      <dl>
        {departureDate && (
          <div>
            <dt>
              <Trans>Departure</Trans>
            </dt>
            <dd>
              <DateOnlyFormat
                value={departureDate}
                format={{
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                }}
              />
            </dd>
          </div>
        )}
        {arrivalDate && (
          <div>
            <dt>
              <Trans>Arrival</Trans>
            </dt>
            <dd>
              <DateOnlyFormat
                value={arrivalDate}
                format={{
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                }}
              />
            </dd>
          </div>
        )}
        <div>
          <dt>
            <Trans>Duration</Trans>
          </dt>
          <dd>
            <Plural value={duration || 0} one="# DAY" other="# DAYS" />
          </dd>
        </div>
        {shipName && (
          <div>
            <dt>
              <Trans>Ship</Trans>
            </dt>
            <dd>{shipName}</dd>
          </div>
        )}
      </dl>
    </div>
  );
};

export default React.memo(CruiseRecap);
